/** The rail's tab strip (unit convention §1). */
import React from 'react';

import {useRailTabsModel} from './model';
import RailTabsView from './View';

export default React.memo(function RailTabs() {
  return <RailTabsView {...useRailTabsModel()} />;
});
